import { createSelector, createSelectorCreator, lruMemoize } from 'reselect';
import { equals } from 'ramda';


export const createKeyMatchSelector = createSelectorCreator(lruMemoize, (a,b) => a === undefined || b === undefined || equals(Object.keys(a), Object.keys(b)));